import React from 'react';

/** Placeholder block. Shapes should approximate the real content so nothing jumps. */
const Skeleton = ({ w = '100%', h = 12, rounded = 'sm', className = '', style }) => (
    <span
        aria-hidden="true"
        className={`skeleton block ${className}`}
        style={{
            width: typeof w === 'number' ? `${w}px` : w,
            height: typeof h === 'number' ? `${h}px` : h,
            borderRadius: rounded === 'full' ? 999 : `var(--radius-${rounded})`,
            ...style,
        }}
    />
);

export const SkeletonText = ({ lines = 3, className = '' }) => (
    <div className={`space-y-2 ${className}`}>
        {Array.from({ length: lines }).map((_, i) => (
            <Skeleton key={i} h={10} w={i === lines - 1 ? '62%' : '100%'} />
        ))}
    </div>
);

export const StatCardSkeleton = () => (
    <div className="card p-4 min-h-[124px] flex flex-col">
        <div className="flex items-start justify-between">
            <Skeleton w={96} h={10} />
            <Skeleton w={17} h={17} />
        </div>
        <Skeleton w={64} h={26} className="mt-3" />
        <div className="mt-auto pt-3">
            <Skeleton w={110} h={10} />
        </div>
    </div>
);

export const ChartSkeleton = ({ height = 240 }) => (
    <div className="flex items-end gap-2.5 px-1" style={{ height }} aria-hidden="true">
        {[58, 82, 45, 96, 68, 74, 52, 88].map((v, i) => (
            <Skeleton key={i} w="100%" h={`${v}%`} />
        ))}
    </div>
);

export const TableSkeleton = ({ rows = 6, cols = 5 }) => (
    <div className="divide-y divide-[var(--divider-color)]" role="status" aria-label="Loading">
        <div className="flex gap-4 px-3.5 py-2.5 bg-[var(--bg-subtle)]">
            {Array.from({ length: cols }).map((_, i) => (
                <Skeleton key={i} h={9} w={i === 0 ? '26%' : '14%'} />
            ))}
        </div>
        {Array.from({ length: rows }).map((_, r) => (
            <div key={r} className="flex gap-4 px-3.5 py-3.5 items-center">
                {Array.from({ length: cols }).map((_, c) => (
                    <Skeleton key={c} h={11} w={c === 0 ? '26%' : '14%'} />
                ))}
            </div>
        ))}
    </div>
);

export const ListSkeleton = ({ rows = 4 }) => (
    <div className="space-y-3" role="status" aria-label="Loading">
        {Array.from({ length: rows }).map((_, i) => (
            <div key={i} className="flex items-center gap-3">
                <Skeleton w={30} h={30} rounded="full" />
                <div className="flex-1 space-y-1.5">
                    <Skeleton h={11} w="52%" />
                    <Skeleton h={9} w="32%" />
                </div>
            </div>
        ))}
    </div>
);

export default Skeleton;
